/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { SEND_REMAINDER } from "../graphql";

const is = require("is_js");
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISendRemainderMethods extends IPluginMethodMap {
  sendRemainder(args: any): Promise<any>;
}

export class SendRemainderService implements IAgentPlugin {
  readonly methods: ISendRemainderMethods;

  constructor() {
    this.methods = {
      sendRemainder: this.sendRemainder.bind(this),
    };
  }

  async sendRemainder(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(args);
    try {
      if (client) {
        const res = await client.mutate({
          mutation: SEND_REMAINDER,
          variables: {
            input: {
              presentation: args?.presentation,
              paymentStats: args?.status
            }
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data?.sendRemainderEmailForUsers) {
          return {
            ...res?.data?.sendRemainderEmailForUsers,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
